export default "__VITE_PUBLIC_ASSET__4d20e0f3__"